export const PROCESS_NOW_LABEL: string = "ProcessNow";
export const EDIT_LABEL: string = "Edit";
export const DELETE_NOW_LABEL: string = "Delete";

